var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62565 15.8334C5.62565 15.8334 6.66732 13.125 10.0007 13.125C13.334 13.125 14.3757 15.8334 14.3757 15.8334M11.8757 8.33337C11.8757 8.83065 11.6781 9.30757 11.3265 9.6592C10.9748 10.0108 10.4979 10.2084 10.0007 10.2084C9.50337 10.2084 9.02646 10.0108 8.67483 9.6592C8.3232 9.30757 8.12565 8.83065 8.12565 8.33337C8.12565 7.83609 8.3232 7.35918 8.67483 7.00755C9.02646 6.65592 9.50337 6.45837 10.0007 6.45837C10.4979 6.45837 10.9748 6.65592 11.3265 7.00755C11.6781 7.35918 11.8757 7.83609 11.8757 8.33337ZM6.45898 16.0417H13.5423C14.2054 16.0417 14.8412 15.7783 15.3101 15.3095C15.7789 14.8406 16.0423 14.2047 16.0423 13.5417V6.45837C16.0423 5.79533 15.7789 5.15945 15.3101 4.69061C14.8412 4.22177 14.2054 3.95837 13.5423 3.95837H6.45898C5.79594 3.95837 5.16006 4.22177 4.69122 4.69061C4.22238 5.15945 3.95898 5.79533 3.95898 6.45837V13.5417C3.95898 14.2047 4.22238 14.8406 4.69122 15.3095C5.16006 15.7783 5.79594 16.0417 6.45898 16.0417Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareUser);
export default __webpack_public_path__ + "static/media/square-user.9d71664ae71d1bc3d74644c1c051299f.svg";
export { ForwardRef as ReactComponent };